// extracted by mini-css-extract-plugin
export default {"songList":"SongList_songList__Djfhk","text":"SongList_text__IggDd"};